<template>
    <md-list id="schedules">
        <md-list-item v-for="schedule in schedules" :key="schedule.id">
            <span class="md-list-item-text">
                <div class="flex items-center">
                    <span class="day">{{ dayOfWeek(schedule.day_number) + ' : ' }}</span>
                    <div class="flex items-center divide-x-2 divide-gray-300">
                        <span class="px-1 pr-1.5" v-for="subSchedule in schedule.schedules" :key="subSchedule.id">
                            {{ subSchedule.start + ' à ' + subSchedule.end }}
                        </span>
                    </div>
                </div>
            </span>
        </md-list-item>
    </md-list>
</template>

<script>
import dateTimeFormattingMixin from '@/mixins/date-time-formatting-mixin'
export default {
    name: "SiteSchedules",
    props: {
        schedules: Array
    },
    mixins: [dateTimeFormattingMixin]
}
</script>

<style scoped>

</style>
